import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { extendCommonGroupsStylesheet } from "@devowl-wp/web-cookie-banner";
import { CookiePropertyList } from "./cookiePropertyList.js";
import { useStylesheet } from "../../../contexts/stylesheet.js";
import { useA11yId } from "../../../hooks/useA11yId.js";
import { useBannerOrBlocker } from "../../../hooks/useBannerOrBlocker.js";
import { Checkbox } from "../checkbox.js";
const Cookie = ({ cookie, checked, disabled, onToggle, propertyListProps = {} })=>{
    const { Cookie } = useStylesheet().extend(...extendCommonGroupsStylesheet);
    const { name } = cookie;
    const { group: { descriptionFontSize } } = useBannerOrBlocker();
    const a11yCheckboxDescription = useA11yId();
    return /*#__PURE__*/ _jsxs(Cookie, {
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                isChecked: checked,
                isDisabled: disabled,
                fontSize: descriptionFontSize,
                onToggle: onToggle,
                "aria-describedby": a11yCheckboxDescription,
                children: /*#__PURE__*/ _jsx("strong", {
                    children: name
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                id: a11yCheckboxDescription,
                children: /*#__PURE__*/ _jsx(CookiePropertyList, {
                    cookie: cookie,
                    ...propertyListProps,
                    isDisabled: !checked
                })
            })
        ]
    });
};
export { Cookie };
